import firebase from "../../components/Firebase.js";

function getMarketplaceScope(userInfo, pickupLocationDetails) {
  const location =
    userInfo.userType === "individual"
      ? userInfo.pickupLocation
      : pickupLocationDetails;
  const hub = location?.pickupLocation ? location : null;
  return {
    distributionLocationUserId: (hub?.pickupLocation || location)?.userId,
    communityLocationUserId: hub?.userId || "",
    communityLocationFarmList: hub?.communityLocationFarmList || [],
  };
}

function createCatalogueQuery(database, farm, userInfo, scope) {
  let query = database
    .collection("FoodItems")
    .where("userType", "==", "admin")
    .where("adminVisible", "==", true);
  if (farm != null || userInfo.userType !== "distributionLocation") {
    query = query.where("farmName", "==", farm);
  }
  if (userInfo.userType !== "distributionLocation") {
    query = query.where("distributionLocationVisible", "array-contains-any", [
      scope.distributionLocationUserId,
      scope.communityLocationUserId,
    ]);
  }
  return query.orderBy("item");
}

function itemIsAvailable(food, scope) {
  if (food.communityLocationDisable?.includes(scope.communityLocationUserId)) {
    return false;
  }
  return (
    scope.communityLocationFarmList.length === 0 ||
    scope.communityLocationFarmList.some(
      (farmer) => farmer.farmName === food.farmName,
    )
  );
}

// Browsing and export pagination share visibility and community-hub rules.
// Use the raw query cursor: a page may contain items excluded by hub rules.
export async function loadMarketplaceCataloguePage({
  farm,
  userInfo,
  pickupLocationDetails,
  loadLimit,
  after,
}) {
  const scope = getMarketplaceScope(userInfo, pickupLocationDetails);
  let query = createCatalogueQuery(firebase.firestore(), farm, userInfo, scope);
  if (after) {
    query = query.startAfter(after);
  }
  const snapshot = await query.limit(loadLimit).get();
  const items = snapshot.docs
    .map((doc) => ({ ...doc.data(), quantity: 0 }))
    .filter((food) => itemIsAvailable(food, scope));
  return {
    farm,
    items,
    lastDocument: snapshot.docs[snapshot.docs.length - 1],
    hasMore: snapshot.docs.length === loadLimit,
    loadLimit,
  };
}

export async function loadRemainingMarketplaceProducts(
  initialPages,
  selectedFarms,
  userInfo,
  pickupLocationDetails,
) {
  const selected = new Set(selectedFarms);
  const remainingItems = await Promise.all(
    initialPages
      .filter((page) => selected.has(page.farm))
      .map(async (initialPage) => {
        if (initialPage.error) {
          throw new Error("The marketplace catalogue could not be loaded.");
        }
        const items = [];
        let page = initialPage;
        while (page.hasMore) {
          page = await loadMarketplaceCataloguePage({
            farm: page.farm,
            userInfo,
            pickupLocationDetails,
            loadLimit: page.loadLimit,
            after: page.lastDocument,
          });
          items.push(...page.items);
        }
        return items;
      }),
  );
  return remainingItems.flat();
}
